import { Component, OnDestroy } from '@angular/core';
import {AlertService} from "./alert.service";

@Component({
  selector: 'jhi-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements  OnDestroy {

  constructor(protected alertService: AlertService) {
  }

  ngOnDestroy():void {
    this.alertService.close()
  }


}
